import { render } from "./InsertSubject.vue?vue&type=template&id=469997d8&scoped=true"
import script from "./InsertSubject.vue?vue&type=script&lang=js"
export * from "./InsertSubject.vue?vue&type=script&lang=js"

import "./InsertSubject.vue?vue&type=style&index=0&id=469997d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469997d8"]])

export default __exports__